let navigateInstance = null;
let currentPathname = null;

// Navigation instance you can navigate by it.
export const setNavigator = (navigator) => {
  navigateInstance = navigator;
};

// Add current path
export const setCurrentPath = (pathname) => {
  currentPathname = pathname;
};

// Handle error
export const handleApiError = (error) => {
  if (error?.response?.status === 401 && navigateInstance) {
    localStorage.removeItem("authToken");
    if (currentPathname?.startsWith("/admin")) {
      navigateInstance("/admin/administrator");
    } else {
      navigateInstance("/");
    }
  }
  return Promise.reject(error);
};
